// extracted by mini-css-extract-plugin
module.exports = {"toast":"styles__toast___hpU_v","success":"styles__success___3jrCs","error":"styles__error___McHVw","text":"styles__text___3xEoP"};